module.exports = __webpack_public_path__ + "static/media/worship2.2eb29c56.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/worker-config/worship2.png
// module id = 353
// module chunks = 0